import { useState } from "react";
import updateDocDataFieldApi from "../../../api/database/updateDocDataFieldApi";
import InfoCell from "../../../listviews/InfoCell";
import { getDocDataByRef } from "../../../models/DataFunctions";
import NotesFolder from "../../../notes/NotesFolder";
import { formatSize } from "../../parameters/Facturation";
import Tippy from "@tippyjs/react";
import TextField2 from "../../../textfields/TextField2";
import { isFolderAdmin } from "../FolderHelpers";
import { particulierActivated } from "../../../hexagone/VisibilityHelpers";
import CustomAccordion from "../../../layout/CustomAccordion";

export const FolderInformationSection = ({
  folderData,
  orgData,
  userData,
  clientData,
  masterData,

  handleFetchData,
  setFolderData,
  prefix,
  handleClickVariant,
}) => {
  function getDelayedDate() {
    const dateinterventionseconds = folderData.intervention_time_int
      ? folderData.intervention_time_int.seconds
      : null;
    const finalisationseconds = folderData.finalised_date?.seconds
      ? folderData.finalised_date.seconds
      : null;
    if (dateinterventionseconds && finalisationseconds) {
      const diff = finalisation - dateintervention;
      const diffDays = diff / (3600 * 24);
      const roundedDays = Math.round(diffDays);
      return roundedDays;
    } else {
      return "?";
    }
  }

  const handleChangeInfoCell = async (field, value) => {
    if (value === null) return;
    if (field === "num") {
      setFolderData({ ...folderData, num: value });
    }
    if (field === "pc_number") {
      setFolderData({ ...folderData, pc_number: value });
    }
    if (field === "adresse") {
      setFolderData({ ...folderData, adresse: value });
    } else if (field === "email") {
      setFolderData({
        ...folderData,
        particulier: {
          ...folderData.particulier,
          email: value,
        },
      });
    } else if (field === "phone") {
      setFolderData({
        ...folderData,

        particulier: {
          ...folderData.particulier,
          phone: value,
        },
        reglement: {
          ...folderData.reglement,
          infos: { ...folderData.reglement.infos, phone: value },
        },
      });
    }
  };

  const handleSyncInfoCell = async (field, value) => {
    if (!value) return;

    await updateDocDataFieldApi(folderData.ref, field, value, prefix);

    if (field === "adresse") {
      await updateDocDataFieldApi(
        folderData.ref,
        "reglement.infos.address",
        value,
        prefix
      );

      if (folderData.event_ref) {
        const event = await getDocDataByRef(folderData.event_ref);
        if (event) {
          await updateDocDataFieldApi(event.ref, "address", value, prefix);
          handleClickVariant("Adresse mise à jour pour l'évènement", "success");
        }
      }
    }
    handleClickVariant("Champ mis à jour", "success");
    handleFetchData();
  };

  return (
    <>
      <div className="flex flex-col w-c350 min-w-c350 gap-1 ">
        <CustomAccordion title="Informations" userData={userData}>
          <div className="flex flex-col w-full gap-1 mt-2">
            <EditableInfoCell
              title="Numéro"
              folderData={folderData}
              data={folderData.num}
              onChangeData={(e) => handleChangeInfoCell("num", e.target.value)}
              handleSync={() => handleSyncInfoCell("num", folderData.num)}
              orgData={orgData}
            />

            <EditableInfoCell
              title="N° Permis de construire"
              folderData={folderData}
              data={folderData.pc_number}
              onChangeData={(e) =>
                handleChangeInfoCell("pc_number", e.target.value)
              }
              handleSync={() =>
                handleSyncInfoCell("pc_number", folderData.pc_number)
              }
              orgData={orgData}
            />

            <InfoCell title="Nom" data={folderData?.nom} />
            <InfoCell
              title="Auteur"
              data={
                folderData?.author_id === masterData.id
                  ? "Infiltromètre"
                  : folderData?.author_id === clientData?.id
                    ? "Client"
                    : "Bureau d'étude"
              }
            />
            <InfoCell title="Structure" data={folderData?.structure_type} />
            <InfoCell
              title="Client"
              data={
                folderData?.marque || folderData?.folder_entreprise_name || ""
              }
            />
            {particulierActivated(folderData) && (
              <>
                <EditableInfoCell
                  title="Email"
                  folderData={folderData}
                  data={folderData.particulier?.email}
                  onChangeData={(e) =>
                    handleChangeInfoCell("email", e.target.value)
                  }
                  handleSync={() =>
                    handleSyncInfoCell(
                      "particulier.email",
                      folderData.particulier?.email
                    )
                  }
                  orgData={orgData}
                />
                <EditableInfoCell
                  title="Téléphone"
                  folderData={folderData}
                  data={folderData.particulier?.phone}
                  onChangeData={(e) =>
                    handleChangeInfoCell("phone", e.target.value)
                  }
                  handleSync={() => {
                    handleSyncInfoCell(
                      "particulier.phone",
                      folderData.particulier?.phone
                    );
                    handleSyncInfoCell(
                      "reglement.infos.phone",
                      folderData.particulier?.phone
                    );
                  }}
                  orgData={orgData}
                />
              </>
            )}
            <InfoCell title="Type" data={folderData?.pack_name} />
            <InfoCell title="Code Postal" data={folderData?.postal} />

            <EditableInfoCell
              title="Adresse"
              data={folderData.adresse}
              onChangeData={(e) =>
                handleChangeInfoCell("adresse", e.target.value)
              }
              restricted={false}
              folderData={folderData}
              handleSync={() =>
                handleSyncInfoCell("adresse", folderData.adresse)
              }
              orgData={orgData}
            />
            <InfoCell title="Ville" data={folderData?.ville} />
            <InfoCell
              title="Création"
              data={
                folderData?.created_time
                  ? new Date(
                      folderData?.created_time?.seconds * 1000
                    ).toLocaleString()
                  : "?"
              }
            />
            <InfoCell
              title="Intervention"
              data={
                folderData?.intervention_realisee ? " réalisée" : " à venir"
              }
            />
            <InfoCell
              title="Intervention"
              data={
                folderData?.dateintervention
                  ? new Date(
                      folderData?.dateintervention?.seconds * 1000
                    ).toLocaleString()
                  : "?"
              }
            />

            <InfoCell
              title="Finalisation"
              data={
                folderData?.finalised_date
                  ? new Date(
                      folderData?.finalised_date?.seconds * 1000
                    ).toLocaleString()
                  : "?"
              }
            />
            <InfoCell title="Délai" data={getDelayedDate()} />
            <InfoCell
              title="Taille"
              data={formatSize(folderData.octets || 0)}
            />
          </div>
        </CustomAccordion>

        {isFolderAdmin(orgData, folderData) && (
          <CustomAccordion title="Notes" userData={userData}>
            <div className="text-h1 font-semibold mb-2 mt-10">
              Notes Dossier
            </div>

            <div className="pr-3 w-full max-w-c400">
              <NotesFolder
                userData={userData}
                orgData={orgData}
                folder={folderData}
                onUpdate={handleFetchData}
              ></NotesFolder>
            </div>
          </CustomAccordion>
        )}
      </div>
    </>
  );
};

export const EditableInfoCell = ({
  title,
  data,
  onChangeData,
  handleSync,
  orgData,
  folderData,
  restricted = true,
}) => {
  const [editable, setEditable] = useState(false);

  const handleSet = () => {
    setEditable(false);
    handleSync();
    // Add additional logic if needed for "onEnter"
  };

  const onChange = (e) => {
    onChangeData(e);
  };

  return (
    <div className="cursor-pointer w-full">
      {!editable && (
        <div
          onClick={() => {
            (!restricted || isFolderAdmin(orgData, folderData)) &&
              setEditable(!editable);
          }}
        >
          <Tippy
            content="Cliquez pour éditer"
            className="custom-tooltip"
            delay={500}
          >
            <div>
              <InfoCell title={title} data={data} editable={true} />
            </div>
          </Tippy>
        </div>
      )}
      {editable && (
        <div>
          <Tippy
            content="Appuyez sur Entrée pour valider"
            className="custom-tooltip"
            delay={500}
          >
            <div>
              <TextField2
                transparent={true}
                value={data}
                onChange={onChange}
                label={title}
                onEnter={handleSet}
              />
            </div>
          </Tippy>
        </div>
      )}
    </div>
  );
};
